import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  svg: {
    width: 'auto',
    height: 28,
  },
});

const BRAND = '#8F93FF';

// SAVR wordmark (isometric cube + "SAVR"), from the frontier design system.
export const LogoFull = () => {
  const classes = useStyles();

  return (
    <svg
      className={classes.svg}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 134 48"
    >
      <path
        fill={BRAND}
        d="M63.0196 21.8098C61.4896 21.5998 59.7196 21.5098 57.8896 21.1798C56.4796 20.9998 55.5796 20.1598 55.5796 18.7198C55.5796 16.4998 57.7996 15.5698 60.0796 15.5698C62.3296 15.5698 64.4896 16.6498 64.5796 19.1698H69.2897C69.2297 14.4898 65.6896 11.5498 60.1096 11.5498C55.4596 11.5498 51.0196 14.3098 51.0196 18.8998C51.0196 22.6498 53.2396 24.9898 57.1096 25.6198C57.8596 25.7698 61.5496 26.1598 62.3296 26.2798C64.0396 26.6098 65.0596 27.3298 65.0596 28.9798C65.0596 31.4098 62.8996 32.3998 60.1096 32.3998C57.0496 32.3998 55.1596 31.0498 55.0396 28.2298H50.3896C50.3896 33.2698 54.1096 36.4498 60.0496 36.4498C65.2696 36.4498 69.6496 33.9898 69.6496 28.8298C69.6496 24.9298 67.3096 22.3798 63.0196 21.8098ZM119.12 27.0298H124.19L128.15 35.9998H133.07L128.69 26.2498C131.27 25.1998 132.98 22.6498 132.98 19.4698C132.98 14.8798 129.8 11.9998 123.86 11.9998H114.56V35.9998H119.12V27.0298ZM128.45 19.4698C128.45 20.5798 128.12 21.4198 127.49 21.9898C126.86 22.5598 125.93 22.8598 124.76 22.8598H119.09V16.0198H123.86C127.22 16.0198 128.45 17.1598 128.45 19.4698ZM98.7797 35.9998H103.82L112.13 11.9998H107.42L101.3 29.8798L95.2097 11.9998H90.3497L98.7797 35.9998ZM86.0896 31.4398L87.6197 35.9998H92.3896L84.0196 11.9998H79.1296L70.7297 35.9998H75.3496L76.8496 31.4398H86.0896ZM78.2896 27.3298L81.4696 17.7898L84.6796 27.3298H78.2896Z"
      />
      <path fill={BRAND} fillOpacity="0.7" d="M42 24L21 12V24L31 30L42 24Z" />
      <path
        fill={BRAND}
        d="M21 12.0001L32.0469 18.3206L32.0679 18.3205L42 12.0001L21 8.39233e-05V12.0001Z"
      />
      <path fill={BRAND} d="M21 24L11 18L0 24L21 36V24Z" />
      <path fill={BRAND} fillOpacity="0.7" d="M0 12L10 6L21 12L11 18L0 12Z" />
      <path fill={BRAND} fillOpacity="0.83" d="M21 0L10 6L21 12V0Z" />
      <path fill={BRAND} fillOpacity="0.83" d="M11 18L0 12V24L11 18Z" />
      <path
        fill={BRAND}
        fillOpacity="0.7"
        d="M21 35.9999L9.95312 29.6794L9.9321 29.6795L0 35.9999L21 47.9999V35.9999Z"
      />
      <path fill={BRAND} d="M21 36L31 30L42 36L32 42L21 36Z" />
      <path fill={BRAND} fillOpacity="0.83" d="M42 24L31 30L42 36V24Z" />
      <path fill={BRAND} fillOpacity="0.83" d="M32 42L21 36V48L32 42Z" />
    </svg>
  );
};
